// [TENANT] In production the API is called on the SAME host as the page
// (igi.ethosboard.com/api/...), and nginx proxies /api to the backend. That way
// the backend sees the client subdomain in the Host header. Do NOT set
// REACT_APP_API_BASE_URL to a different domain (e.g. api.ethosboard.com) for
// production builds, or every client would look like the same host.
// Local development still talks to the backend directly on port 5000.
const DEFAULT_API_BASE =
  process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

/** Full API base URL including `/api` (for axios and public endpoints). */
export const getApiBaseUrl = () => {
  const url = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE;
  return url.replace(/\/+$/, '');
};

/**
 * Server origin without `/api` (for static uploads and attachments).
 * Returns '' in production (same origin), so '/uploads/...' stays relative.
 */
export const getApiOrigin = () => getApiBaseUrl().replace(/\/api\/?$/, '');

/**
 * Build URL for a server-relative asset path (e.g. `/uploads/...` or `uploads/forums/...`).
 * Supports REACT_APP_BASE_URL or derives from REACT_APP_API_BASE_URL.
 */
export const getAssetUrl = (filePath) => {
  if (!filePath) return '';
  if (typeof filePath !== 'string') return '';
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }

  const envBase = process.env.REACT_APP_BASE_URL;
  const origin = (envBase || getApiOrigin()).replace(/\/api\/?$/, '').replace(/\/+$/, '');
  const path = filePath.startsWith('/') ? filePath : `/${filePath}`;
  return `${origin}${path}`;
};

/** Build SCORM module launch URL (same-origin; proxied to backend in dev via setupProxy). */
export const getScormLaunchUrl = (scormPath, launchFile) => {
  if (!scormPath || !launchFile) return '';
  const base = (process.env.REACT_APP_SCORM_BASE_URL || '').replace(/\/+$/, '');
  const launchPath =
  `/scorm/${encodeURIComponent(scormPath)}/${launchFile}`
    .replace(/\/{2,}/g, '/');
  return base ? `${base}${launchPath}` : launchPath;
};

/** Course thumbnail on landing pages. */
export const getCourseImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const imageBase = process.env.REACT_APP_IMAGE_BASE_URL;
  if (imageBase) {
    const base = imageBase.replace(/\/+$/, '');
    const file = imagePath.replace(/^\/+/, '').replace(/^uploads\/courses\//, '');
    return `${base}/${file}`;
  }

  const filename = imagePath.replace(/^\/+/, '').replace(/^uploads\/courses\//, '');
  return `${getApiOrigin()}/uploads/courses/${filename}`;
};